import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const TextDataTypeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "TextDataType",
    children: /*#__PURE__*/_jsx("path", {
      d: "M7.77 11.33a.87.87 0 0 0-.35-.46.95.95 0 0 0-.53-.17c-.2-.03-.39.03-.56.14s-.3.28-.38.49l-3.91 9.36c-.03.11-.04.2-.04.3 0 .22.07.41.2.57.14.16.35.24.64.24.18 0 .34-.05.49-.17.15-.11.27-.27.34-.46l.81-1.91h4.67l.81 1.89c.08.2.2.36.35.47.16.12.32.18.51.18.22 0 .42-.08.6-.25s.28-.39.28-.67c0-.12-.03-.24-.08-.38l-3.87-9.17Zm-2.52 6.13 1.56-3.67 1.58 3.67H5.26ZM19.68 13.74c-.57-.37-1.23-.55-1.96-.55-.37 0-.71.06-1.04.18q-.495.195-.87.48c-.23.17-.41.35-.55.53v-3.29c0-.27-.08-.5-.27-.68-.17-.18-.39-.28-.67-.28s-.5.1-.67.28-.27.41-.27.68v9.84c0 .28.1.51.27.69s.4.25.67.25.5-.1.67-.27c.18-.18.27-.41.27-.68v-.11a3.786 3.786 0 0 0 1.33.85c.37.14.76.2 1.18.2.71 0 1.35-.18 1.92-.55s1.02-.88 1.36-1.53c.34-.66.51-1.41.51-2.27s-.17-1.61-.51-2.26-.81-1.15-1.38-1.53v.02Zm-.2 5.12c-.19.4-.46.72-.8.95s-.74.34-1.2.34-.87-.11-1.21-.34c-.35-.23-.62-.54-.81-.95-.19-.39-.29-.85-.29-1.34s.1-.95.29-1.35c.19-.38.46-.7.81-.93.34-.23.74-.34 1.21-.34s.86.11 1.2.34c.33.23.6.54.8.93.19.39.3.85.3 1.35s-.11.94-.3 1.34M29.78 19.82c-.15-.18-.36-.26-.63-.26-.23 0-.4.04-.52.14-.11.1-.25.18-.39.26-.12.06-.28.11-.47.14-.18.04-.41.04-.67.04-.47 0-.88-.11-1.24-.34s-.64-.54-.85-.94c-.2-.39-.31-.84-.31-1.34s.1-.96.3-1.36.48-.7.86-.94c.37-.23.82-.34 1.36-.34.11 0 .26.02.48.05.21.03.38.09.47.15.11.06.21.13.3.2s.18.13.29.18c.11.04.25.07.42.07.24 0 .42-.09.55-.27.12-.18.18-.38.18-.59 0-.31-.12-.59-.37-.81-.25-.23-.59-.4-1.03-.53s-.96-.18-1.56-.18c-.81 0-1.51.18-2.14.56-.62.37-1.1.88-1.45 1.53-.35.66-.53 1.41-.53 2.27s.17 1.55.49 2.21c.33.66.8 1.17 1.4 1.56.6.38 1.32.57 2.14.57.55 0 1.07-.07 1.54-.19.47-.13.86-.31 1.15-.52s.44-.46.44-.71-.07-.46-.22-.63Z"
    })
  }));
};